<template>
  <c-container fluid class="d-flex content-center min-vh-100 login-container c-app c-dark-theme">
    <logo-long-boss />
    <c-row>
      <c-col>
        <c-card-group>
          <c-card class="p-4 login-form">
            <c-card-body>
              <c-form @submit.prevent="login">
                <p class="h4">Log in to access KoalaBoss</p>

                <c-alert show color="warning" v-if="error" close-button class="mt-4">
                  {{ error }}
                </c-alert>

                <div class="login-fields">
                  <c-input
                    v-model="data.body.username"
                    placeholder="Email address"
                    autocomplete="off"
                    :disabled="isLoggingIn"
                  >
                    <template #prepend-content><c-icon name="cil-user" /></template>
                  </c-input>

                  <c-input
                    v-if="authType"
                    placeholder="Password"
                    v-model="data.body.password"
                    type="password"
                    autocomplete="off"
                    :disabled="isLoggingIn"
                  >
                    <template #prepend-content><c-icon name="cil-lock-locked" /></template>
                  </c-input>

                  <template v-if="authType === 'mfa'">
                    <p>
                      Oh goodie! You have MFA enabled on your account. Enter the 6 digit code found in your
                      authentication app below. If you need help, or don't remember what MFA is,
                      <a href="https://koalaboss.com/help/mfa" target="_blank">click here</a>
                      .
                    </p>
                    <c-input
                      v-model="data.body.token"
                      placeholder="Authentication code"
                      autocomplete="off"
                      :disabled="isLoggingIn"
                    >
                      <template #prepend-content><c-icon name="cil-code" /></template>
                    </c-input>
                  </template>
                </div>
                <c-row class="mt-4">
                  <c-col col="12" class="text-center">
                    <c-button v-if="authType" type="submit" class="px-4 w-100 btn-primary">
                      <CSpinner v-if="isLoggingIn" color="success" size="sm"/>
                      <span v-else>Login</span>
                    </c-button>
                    <c-button v-else @click="checkAuthType" class="px-4 w-100 btn-primary">
                      <CSpinner v-if="isLoggingIn" color="success" size="sm"/>
                      <span v-else>Continue</span>
                    </c-button>
                  </c-col>
                </c-row>

                <c-row class="mt-3">
                  <c-col col="12" class="text-center">
                    <CButton color="link" class="px-0 link" :to="{ name: 'passwordForgot' }">Forgot password?</CButton>
                  </c-col>
                </c-row>
              </c-form>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
    <c-row class="mt-3">
      <c-col col="12" class="text-center">
        <span class="small">
          Don't have an account?
          <a class="px-0 link" href="https://koalaboss.com" target="_blank">Get one</a>
        </span>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';
import LogoLongBoss from '@/views/components/images/long-boss';

export default {
  name: 'Login',
  components: {
    LogoLongBoss,
  },
  data() {
    return {
      isLoggingIn: false,
      error: null,
      authType: null,
      data: {
        body: {
          username: null,
          password: null,
          token: null,
        },
        rememberMe: false,
        requiredFields: {
          username: false,
          password: false,
        },
      },
    };
  },

  watch: {
    'data.body.username': function (val) {
      if (val) {
        this.data.requiredFields.username = false;
      }
    },
    'data.body.password': function (val) {
      if (val) {
        this.data.requiredFields.password = false;
      }
    },
  },

  mounted() {
    if (Object.keys(this.$auth.user()).length) {
      window.location = '/';
    }
  },
  methods: {
    checkAuthType() {
      if (!this.data.body.username) {
        this.data.requiredFields.username = true;
        return;
      }
      this.isLoggingIn = true;
      this.$http
        .post(buildEndpoint('check-auth'), this.data.body)
        .then((response) => {
          this.authType = response.data.data.mfa ? 'mfa' : 'standard';
          this.isLoggingIn = false;
        })
        .catch((error) => {
          this.isLoggingIn = false;
          this.error = 'There was an error logging into KoalaBoss, please try again.';
        });
    },
    login() {
      if (!this.data.body.username) {
        this.data.requiredFields.username = true;
        return;
      }
      if (!this.data.body.password) {
        this.data.requiredFields.password = true;
        return;
      }

      if (this.authType === 'mfa' && !this.data.body.token) {
        return;
      }

      this.isLoggingIn = true;

      // Get rid of surrounding spaces
      this.data.body.username = _.trim(this.data.body.username);
      this.data.body.password = _.trim(this.data.body.password);
      this.data.body.token = _.trim(this.data.body.token);

      setTimeout(() => {
        this.$auth.login({
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.data.body,
          rememberMe: this.data.rememberMe,
          redirect: { name: 'dashboard', query: { refresh: '1' } },
          success(res) {
            // Do nothing
          },
          error(err) {
            this.isLoggingIn = false;
            if (err.response) {
              // The request was made, but the server responded with a status code
              // that falls out of the range of 2xx
              this.error = err.response.data.message;
            } else {
              // Something happened in setting up the request that triggered an Error
              this.error = 'There was an error logging into KoalaBoss, please try again.';
            }
          },
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss"></style>
